export default __webpack_public_path__ + "static/media/chair-with-no-back.bb1663e7.webp";